module.exports = __webpack_public_path__ + "img/eaten-brigadeiro.0b5f88dc.svg";